module.exports = __webpack_public_path__ + "static/media/google_translate_logo_gray.49cd47d4.svg";